define.alias("shared/components/shared/collapsable-info-card", "preview-grid/components/shared/collapsable-info-card");